<template>
  <BuyerOneColumnPage
    :title="title"
    subTitle="Suas cotações não concretizadas"
    :icon="icon"
    :section="section"
    :description="description"
    :getContent="getQuotesUnfufilled"
    labelCard="Sua última cotação"
    buyerScope="UnfulilledPurchases"
    noVehicleLabel="Você ainda não cotou nenhum veículo…"
    priceBackgroundColor="#F22300"
  />
</template>

<script>
import { BUYER_SECTION_CLOSED } from "@/views/buyer/constants/BuyerSections";

import PlatformsMixins from "@/mixins/PlatformsMixins";
import BuyerComponentPagesMixins from "@/mixins/BuyerComponentPagesMixins";

import { getQuotesUnfufilled } from "@/services/api/BuyerServiceApi";

import BuyerOneColumnPage from "../../BuyerOneColumnPage";

export default {
  name: "QuotesUnfulfilledPurchasesPage",
  mixins: [PlatformsMixins, BuyerComponentPagesMixins],
  components: { BuyerOneColumnPage },
  data: function () {
    return {
      ...BUYER_SECTION_CLOSED,
      title: "Não concretizadas - Cotações",
      section: "Encerrados",
    };
  },
  methods: {
    getQuotesUnfufilled,
  },
};
</script>

<style scoped></style>
